import { useHistory } from 'react-router-dom';
import { PAGE_PATH_NAME } from '../utils/const';
import useAccessKey from './useAccessKey';

// 本カスタムフックの返り値
export type UseAutoLogoffValue = {
  onClickClose: () => void;
};

const useAutoLogoff = (): UseAutoLogoffValue => {
  // アクセスキー
  const { reset } = useAccessKey();

  // history
  const history = useHistory();

  // 閉じるボタン押下時処理
  const onClickClose = () => {
    // ローカルストレージのアクセスキーを削除する
    reset();

    // シリアル入力画面に遷移
    history.replace(PAGE_PATH_NAME.SERIAL_INPUT);
  };

  return {
    onClickClose,
  };
};
export default useAutoLogoff;
